import React from 'react';
import spectrocoin from 'assets/img/icons/spectrocoin-icon.svg';
import exchange from 'assets/img/icons/exchange-icon.svg';
import investment from 'assets/img/icons/investment-icon.svg';
import wallet from 'assets/img/icons/wallet-icon.svg';
import loans from 'assets/img/icons/loans-icon.svg';
import arrow from 'assets/img/icons/arrow-down.svg';
import arrowGreen from 'assets/img/icons/arrow-down-green.svg';
import close from 'assets/img/icons/close.png';

const headerIcon = {
	close,
	spectrocoin,
	exchange,
	investment,
	wallet,
	loans,
	arrow,
	arrowGreen,
	logo: (
		<svg xmlns="http://www.w3.org/2000/svg" width="147" height="18.772" viewBox="0 0 147 18.772">
			<g transform="translate(-468.977 -645.534)" className="a">
				<path
					data-name="Path 20032"
					d="M468.977,645.534h10.639c3.715,0,5.488,2.42,5.488,4.784a4.193,4.193,0,0,1-3.208,4.306,4.5,4.5,0,0,1,3.574,4.587c0,2.73-1.829,5.094-5.516,5.094H468.977Zm9.541,7.261a1.589,1.589,0,0,0,1.66-1.632,1.567,1.567,0,0,0-1.66-1.6h-4.7v3.236Zm.169,7.486a1.68,1.68,0,0,0,1.858-1.717,1.737,1.737,0,0,0-1.858-1.773h-4.869v3.49Z"
					transform="translate(0 0)"
				/>
				<path
					data-name="Path 20033"
					d="M527.027,661.463h-7.8l-.957,2.843h-5.262l7.064-18.772h6.079l7.092,18.772h-5.263Zm-6.529-4.081h5.263l-2.646-7.627Z"
					transform="translate(-24.693 0)"
				/>
				<path
					data-name="Path 20034"
					d="M572.8,652.964v11.342h-4.841V645.534h4.982l7.6,10.807V645.534H585.4v18.772h-4.672Z"
					transform="translate(-55.503 0)"
				/>
				<path
					data-name="Path 20035"
					d="M627.438,657.242l-1.267,1.576v5.488h-4.841V645.534h4.841v7.711l5.77-7.711h5.967l-7.29,8.781,7.683,9.991h-5.938Z"
					transform="translate(-85.433 0)"
				/>
				<path
					data-name="Path 20036"
					d="M668.869,645.534h13.762v4.081H673.71v3.124h8.724v4.109H673.71v3.377h8.921v4.081H668.869Z"
					transform="translate(-112.09 0)"
				/>
				<path
					data-name="Path 20037"
					d="M720.374,657.945H717.9v6.361h-4.841V645.534h9.4c4.166,0,6.53,2.758,6.53,6.248a5.687,5.687,0,0,1-3.743,5.629l3.828,6.9h-5.544Zm1.351-8.33H717.9v4.222h3.828a2.122,2.122,0,1,0,0-4.222Z"
					transform="translate(-136.868 0)"
				/>
				<path
					data-name="Path 20038"
					d="M771.588,661.463h-7.8l-.957,2.843h-5.263l7.064-18.772h6.079l7.092,18.772h-5.263Zm-6.53-4.081h5.263l-2.645-7.627Z"
					transform="translate(-161.83 0)"
				/>
			</g>
		</svg>
	)
};

export default headerIcon;
